import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuthCallback } from '../hooks/useAdminAuthCallback';

export const AdminAuthCallback = ({ sessionId }) => {
  const navigate = useNavigate();
  const complete = useCallback(() => navigate('/admin', { replace: true }), [navigate]);
  const { error, retry } = useAdminAuthCallback(sessionId, complete);

  return (
    <main className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6" data-testid="admin-auth-callback">
      <section className="w-full max-w-md border border-slate-800 bg-slate-900 rounded-2xl p-8 text-center">
        {error ? (
          <>
            <h1 className="text-2xl font-bold mb-3">Admin access denied</h1>
            <p className="text-sm text-red-300 mb-6" data-testid="admin-auth-callback-error">{error}</p>
            <button type="button" onClick={retry} data-testid="admin-auth-retry-button" className="rounded-lg bg-white text-slate-950 px-5 py-2.5 font-semibold hover:bg-slate-100 transition-colors">Try another account</button>
          </>
        ) : (
          <>
            <div className="w-8 h-8 rounded-full border-2 border-slate-700 border-t-emerald-400 animate-spin mx-auto mb-5" aria-hidden="true" />
            <h1 className="text-xl font-bold">Confirming administrator access</h1>
            <p className="text-sm text-slate-500 mt-2" data-testid="admin-auth-callback-status">This should only take a moment.</p>
          </>
        )}
      </section>
    </main>
  );
};
